<template>
  <div class="b-menu-back-bubble__container" :class="classes.position">
    <div class="b-menu-back-bubble" :class="[classes.config]" :title="title" @click="click" :style="[_size]">
      <div class="b-menu-back-bubble__icon-container">
        <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1">
            <polygon fill="currentColor" points="30 13.125 7.125 13.125 17.625 2.625 15 0 0 15 15 30 17.625 27.375 7.125 16.875 30 16.875"></polygon>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import StoreHelper from '../store/helper'
import _ from 'lodash'
import DraggableFactory, { Types, Directions } from '../util/DragAndDrop'

export default {
  name: 'b-menu-back-bubble',
  props: {
    defaultPosition: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: null
    }
  },
  activated () {
    if (StoreHelper.isDraggableBubblesEnabled()) {
      DraggableFactory.register(Types.DROPPABLE_BUBBLE, Directions.UPWARDS, this.$el.querySelector('.b-menu-back-bubble'), this)
    }
  },
  mounted () {
    if (StoreHelper.isDraggableBubblesEnabled()) {
      DraggableFactory.register(Types.DROPPABLE_BUBBLE, Directions.UPWARDS, this.$el.querySelector('.b-menu-back-bubble'), this)
    }
  },
  methods: {
    click () { this.$emit('click') }
  },
  computed: {
    classes () {
      return {
        config: _.get(StoreHelper.getBackButtonConfig(), 'classes', []),
        position: { 'b-menu-back-bubble--default-position': this.defaultPosition }
      }
    },
    _size () {
      return _.isNull(this.size)
        ? { width: `${StoreHelper.getBackBubbleSize()}px`, height: `${StoreHelper.getBackBubbleSize()}px` }
        : { width: `${this.size}`, height: `${this.size}` }
    },
    title () {
      return _.get(StoreHelper.getBackButtonConfig(), 'title', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.b-menu-back-bubble {
  background-color: lightgray;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
  transition: all 200ms cubic-bezier(0, 0, 0.57, 1.57); // TODO: Outsource?

  &__icon-container {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;

    svg {
      height: 50%;
      color: white;
    }
  }
}
.b-menu-back-bubble__container {
  margin: 15px 0 0 15px;
}

.b-menu-back-bubble--default-position {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
}
</style>
